import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { TestRequest } from '../models/TestRequest';
//import { Observable } from 'rxjs/Observable';
//import 'rxjs/add/operator/map';
import { PlatformLocation } from '@angular/common';
//import { ResponseContentType, RequestOptions, Http, Headers } from '@angular/http';

@Injectable({
  providedIn: 'root'
})
export class TestRequestService {

  getTestRequestFile(id: string): any {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token') || "").access_token);
    //headers = headers.append("Content-Type", "application/json");
    headers = headers.append("Accept", "text/plain");
    const options = { headers: headers};
    return this.http.get<Blob>(this.location.getBaseHrefFromDOM() + 'api/testrequest/' + id + '/pdf', options);
  }

  getTestRequest(id: string) {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token') || "").access_token);
    headers = headers.append("Content-Type", "application/json");

    return this.http.get<TestRequest>(this.location.getBaseHrefFromDOM() +'api/testrequest/' + id, { headers: headers });
  }


  constructor(private http: HttpClient, private location: PlatformLocation ) {
  }

  getTestRequests(searchCriteria : any) {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token') || "").access_token);
    headers = headers.append("Content-Type", "application/json");
    let sourceId = JSON.parse(sessionStorage.getItem("source") || "").Id;
    let params: HttpParams = new HttpParams();
    if (searchCriteria) {
      params = params.set("reference", searchCriteria.reference);
      params = params.set("surname", searchCriteria.surname);
      params = params.set("forename", searchCriteria.forename);
      params = params.set("email", searchCriteria.email);
      params = params.set("dob", searchCriteria.dob);
      params = params.set("fromDate", searchCriteria.fromDate);
      params = params.set("toDate", searchCriteria.toDate);
      params = params.set("sourceId", sourceId)
    }

    return this.http.get<TestRequest[]>(this.location.getBaseHrefFromDOM() +'api/testrequest', { headers: headers, params: params });
  }


  submitTestRequest(testRequest: TestRequest): any {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token') || "").access_token);
    headers = headers.append("Content-Type", "application/json");
    headers = headers.append("Accept", "application/octet-stream");
    console.log("headers",headers);
    //const options = new RequestOptions({ responseType: ResponseContentType.Blob, headers: headers });
    return this.http.post(this.location.getBaseHrefFromDOM() + 'api/testrequest',
      JSON.stringify(testRequest),
      { headers, responseType: 'blob' as 'json', observe : 'response' as 'response'}).toPromise();
  }
  ///api/testreqlabno
  submitTestRequestNoPdf(testRequest: TestRequest) {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token') || "").access_token);
    headers = headers.append("Content-Type", "application/json");
    headers = headers.append("Accept", "application/octet-stream");
    console.log("headers", headers);
    //const options = new RequestOptions({ responseType: ResponseContentType.Blob, headers: headers });
    return this.http.post(this.location.getBaseHrefFromDOM() + 'api/testreqlabno',
      JSON.stringify(testRequest),
      { headers}).toPromise();
  }

  deleteTestRequest(id: string) {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token') || "").access_token);
    headers = headers.append("Content-Type", "application/json");

    return this.http.delete<boolean>(this.location.getBaseHrefFromDOM() +'api/testrequest/' + id, { headers: headers });
  }
}
